import { CircularProgress } from "@shuttlerock/mui-components";
import { ReactElement } from "react";
import { useUploadState } from "../../contexts/UploadContext";

export type FileProgressIndicatorProps = {
  scope: string;
  id: string;
};

export const FileProgressIndicator = ({
  scope,
  id,
}: FileProgressIndicatorProps): ReactElement | null => {
  const percentage = useUploadState({
    selector: (state) => {
      const file = state?.[scope]?.files?.[id];

      if (file == null) return 100;

      const progress = file?.progress;
      return progress?.uploadComplete ? 100 : progress?.percentage;
    },
  });

  if (percentage === 100) return null;

  return <CircularProgress variant="determinate" size={20} thickness={4} value={percentage} />;
};
